import React from "react";
import Samoprocena from "../../components/admin/samoprocena";

function SamoprocenaPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <Samoprocena />
    </div>
  );
}

export default SamoprocenaPage;
